import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import {
  StyledList,
  ListHeading,
  StyledLink,
} from './styled';

const getRakstiId = (data) => (
  ((data && Array.isArray(data)) ? data.filter(item => item.hasOwnProperty('pielinkotais_raksts')) : [])
  .map(item => item['pielinkotais_raksts'])
);

const getVirsraksti = (data) => (
  ((data && Array.isArray(data)) ? data.filter(item => item.hasOwnProperty('virsraksts')) : [])
  .map(item => item['virsraksts'])
);

const QUERY = gql`
query SaistitieRakstiQuery($lang: String!, $raksti: [Int]!) {
  page(lang: $lang, _id: $raksti) {
    _id
    title
    path
  }
}`;

const queryOptions = {
  options: ({ lang, saistitieRaksti }) => ({
    fetchPolicy: 'cache-first',
    skip: !saistitieRaksti,
    variables: {
      lang: (lang || 'lv'),
      raksti: getRakstiId(saistitieRaksti),
    }
  }),
  props: props => {
    const { data: {
      loading,
     page,
      ...rest
    }} = props;

    return {
      loading,
      data: {
        page,
      },
      saistitieRaksti: props.ownProps.saistitieRaksti,
    }
  }
}

class SaistitieRaksti extends React.PureComponent {
  render() {
    const { loading, data, saistitieRaksti } = this.props;
    if (loading) {
      return null;
    }

    const renderHeading = (text) => (
      <ListHeading>
        {text}
      </ListHeading>
    );

    const renderLink = (page) => (
      <StyledLink to={page.path} rel='help'>
        {page.title}
      </StyledLink>
    );

    if (saistitieRaksti && Array.isArray(saistitieRaksti)) {
      const list = saistitieRaksti.map(item => {
        const { page } = data;

        if (item.hasOwnProperty('virsraksts')) {
          return renderHeading(item.virsraksts);

        } else if (item.hasOwnProperty('pielinkotais_raksts')) {
          const targetPage = page.find(p => p._id === parseInt(item.pielinkotais_raksts));
          return targetPage && renderLink(targetPage);
        }
      });

      return (
        <StyledList>
          {list.map((item, i) => (
            <li key={i}>
              {item}
            </li>
          ))}
        </StyledList>
      );
    }

    return null;
  }
}

export default compose(
  graphql(QUERY, queryOptions)
)(SaistitieRaksti)



// WEBPACK FOOTER //
// ./src/pages/Raksts/components/SaistitieRaksti/SaistitieRaksti.jsx